import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";

export interface LicenseType {
  readonly name: string;
  readonly description: string;
  readonly category: string;
  readonly initialLogins: number;
  readonly isPlanningEnabled: boolean;
  readonly isAdminEnabled: boolean;
  readonly priceNet: number;
  readonly taxPercent: number;
  readonly tax: number;
  readonly priceTotal: number;
  readonly signature: string;
}

@Injectable({
  providedIn: "root"
})
export class LicenseTypeService {

  public constructor(private readonly _httpClient: HttpClient) {}

  public loadLicenseTypes(): Promise<LicenseType[]> {
    return this._httpClient.get<LicenseType[]>("api/licenseTypes").toPromise();
  }

}
